import { useConfigStore } from "../stores/ConfigStore";
import { useLeadsStore } from "../stores/LeadsStore";
import { mainAxios as axios } from "./axios";

export const getTags = async () => {
  let response = await axios.get("/tags");

  if (response.data.state) {
    useConfigStore.getState().setTags(response.data.tags_list);


    let setPrmOptions = useLeadsStore.getState().setTagOptions;
    setPrmOptions([
      {
        label: "Tags",
        options:
          response.data["tags_list"]
            ?.sort((a, b) => b.id - a.id)
            ?.map((x) => ({ ...x, option_name: x["name"] })) || [],
      },
    ]);
  }

  return response;
};

export const createTag = async ({ name, color }) => {
  let r = await axios.post("/tags", {
    name,
    color
  });

  return r;
};

export const editTag = async ({ id, name, color, sharing }) => {
  return axios.put(`/tags/${id}`, {
    name,
    sharing,
    color
  });
};

export const deleteTag = async ({ id }) => {
  let a = axios.delete(`/tags/${id}`);

  return a;
};

export const handleTags = async (t) => {
  let myTags = useConfigStore.getState().tags;
  let promises = [];
  t.forEach((tag) => {
    let tagExist = myTags?.find((x) => x.name === tag);
    if (!tagExist) {
      promises.push(createTag(tag));
    } else {
      console.log("tag exist !");
    }
  });

  let p = await Promise.all(promises);

  if (p) {
    if (promises.length) return getTags();
    return {
      data: {
        tags_list: myTags,
      },
    };
  }
};
